import { forwardRef } from 'react';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography.styled';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHeader,
  StyledIcon,
  StyledWrapper
} from './DailyContact.styled';
import dynamic from 'next/dynamic';

const ManfredDailyForm = dynamic(() => import('../form/ManfredDailyForm'), {
  ssr: false
});

interface DailyContactProps {}

const DailyContact = forwardRef<HTMLDivElement, DailyContactProps>(
  (props, ref) => {
    const { t } = useI18n('manfred-daily');

    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledHeader>
            <StyledIcon>
              <img
                src={getPublicPath('/images/isotype-manfred-white.svg')}
                alt=""
              />
              <span>{t('manfred-daily.contact.icon')}</span>
            </StyledIcon>
            <Heading2 editorial>{t('manfred-daily.contact.title')}</Heading2>
            <p>
              <HtmlTrans
                ns="manfred-daily"
                i18nKey="manfred-daily.contact.desc"
              />
            </p>
          </StyledHeader>
        </StyledContainer>
        <div ref={ref}>
          <ManfredDailyForm />
        </div>
      </StyledWrapper>
    );
  }
);

DailyContact.displayName = 'DailyContact';

export default DailyContact;
